// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/Users/ben.ely/Sites/gatsby-theme-amplify-cognito/demo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

